import angular from 'angular';

const isEnvDevelopment = environment => {
  var env = (environment || '').toLowerCase();
  return env === 'development' || env === 'local';
};

angular
  .module('cloudX')
  .directive('developmentOnly', [
    'environment',
    function(environment) {
      return {
        restrict: 'A',
        link: function(scope, element, attr) {
          if (!isEnvDevelopment(environment)) element.remove();
        },
      };
    },
  ])
  /*
  Filter variant to use in attributes
  Example:
  ng-if="0|isDevelopment"
  (The value before the pipe is needed for the syntax, but is ignored in the filter. It can be any value)
  */
  .filter('isDevelopment', [
    'environment',
    function(environment) {
      return function() {
        return isEnvDevelopment(environment);
      };
    },
  ]);
